import { Box, Chip, Typography } from '@mui/material';
import { memo, ReactElement, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

export interface StatusChipData {
  label: string;
  config: StatusChipConfig;
}

export interface StatusChipConfig {
  icon: ReactNode;
  bgColor: string;
  color?: string;
}

export interface AnalysisStatusProps {
  chipConfigs: StatusChipData[];
  instructionText: string | null;
}

export const AnalysisStatus = memo(function AnalysisStatus({
  chipConfigs,
  instructionText,
}: AnalysisStatusProps): ReactElement {
  const { t } = useTranslation();
  return (
    <Box
      display='flex'
      flexDirection='column'
      gap={2}
      justifyContent='center'
      alignItems='center'
      height='100%'
      width='100%'
      boxSizing='border-box'
      padding={2}
      paddingTop={0}
    >
      <Box display='flex' flexDirection='row' flexWrap='wrap' gap={2} justifyContent='center' alignItems='center'>
        {chipConfigs.map(({ label, config }, index) => (
          <Chip
            key={index}
            label={
              <Box display='flex' alignItems='center' gap={0.5}>
                {label}
                {config.icon}
              </Box>
            }
            sx={{
              backgroundColor: config.bgColor,
              color: config.color || 'white',
              '& .MuiChip-label': {
                paddingLeft: 1,
                paddingRight: 1,
              },
            }}
          />
        ))}
      </Box>

      {instructionText && (
        <Box width='100%'>
          <Typography variant='h6' textAlign='center'>
            {t(instructionText)}
          </Typography>
        </Box>
      )}
    </Box>
  );
});
